import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogClose } from "../../components/ui/dialog";
import { Plus, Trash2, Building2 } from "lucide-react";

export function TeamManagement({
  teams, managers, showCreateTeam, setShowCreateTeam,
  newTeam, setNewTeam, handleCreateTeam, handleDeleteTeam, handleAssignManager
}) {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-end">
        <Dialog open={showCreateTeam} onOpenChange={setShowCreateTeam}>
          <DialogTrigger asChild>
            <Button className="bg-[#0B1F3B] hover:bg-[#0B1F3B]/90 btn-premium" data-testid="create-team-btn">
              <Plus className="w-4 h-4 mr-2" /> Create Team
            </Button>
          </DialogTrigger>
          <DialogContent className="sm:max-w-md">
            <DialogHeader>
              <DialogTitle className="text-[#0B1F3B]">Create New Team</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Team Name</Label>
                <Input value={newTeam.name} onChange={(e) => setNewTeam({...newTeam, name: e.target.value})} placeholder="e.g. North Region Sales" data-testid="new-team-name" />
              </div>
              <div className="space-y-2">
                <Label>Description (Optional)</Label>
                <Input value={newTeam.description} onChange={(e) => setNewTeam({...newTeam, description: e.target.value})} placeholder="Brief description" data-testid="new-team-desc" />
              </div>
            </div>
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="outline">Cancel</Button>
              </DialogClose>
              <Button onClick={handleCreateTeam} className="bg-[#0B1F3B] hover:bg-[#0B1F3B]/90" data-testid="submit-create-team">
                Create Team
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {teams.map((team) => (
          <Card key={team.id} className="premium-card" data-testid={`team-card-${team.id}`}>
            <CardHeader className="pb-3">
              <div className="flex items-start justify-between">
                <div>
                  <CardTitle className="text-base font-bold text-[#0B1F3B]">{team.name}</CardTitle>
                  {team.description && <CardDescription className="text-xs text-slate-400">{team.description}</CardDescription>}
                </div>
                <Button variant="ghost" size="icon" className="h-8 w-8 text-slate-400 hover:text-red-500"
                  onClick={() => handleDeleteTeam(team.id)}>
                  <Trash2 className="w-4 h-4" />
                </Button>
              </div>
            </CardHeader>
            <CardContent className="space-y-3">
              <div className="flex items-center justify-between text-sm">
                <span className="text-slate-500">Members</span>
                <span className="font-semibold text-[#0B1F3B]">{team.member_count}</span>
              </div>
              <div className="space-y-2">
                <span className="text-sm text-slate-500">Manager</span>
                <Select 
                  value={team.manager?.id || "none"} 
                  onValueChange={(v) => handleAssignManager(team.id, v === "none" ? "" : v)}
                >
                  <SelectTrigger className="h-9 text-sm" data-testid={`team-manager-${team.id}`}>
                    <SelectValue placeholder="Assign manager" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="none">No manager</SelectItem>
                    {managers.map(m => (
                      <SelectItem key={m.id} value={m.id}>{m.name} ({m.role})</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </div>
            </CardContent>
          </Card>
        ))}
        {teams.length === 0 && (
          <Card className="premium-card col-span-full text-center py-12">
            <CardContent>
              <Building2 className="w-10 h-10 text-slate-200 mx-auto mb-3" />
              <p className="text-slate-400 text-sm">No teams created yet</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
